import { useContext } from 'react'

import { StepContext, type StepContextValue } from '../contexts/step-provider'

/**
 * Hook to access the current step state and setter function from step context.
 * Must be used within a StepProvider component tree.
 *
 * @returns Object containing the current step and setStep function
 * @throws Error if used outside of StepProvider
 */
export const useStepContext = (): StepContextValue => {
  const context = useContext(StepContext)
  if (context === undefined) {
    throw new Error('useStepContext must be used within a StepProvider')
  }

  return context
}
